module.exports = __webpack_public_path__ + "img/ecobank.b329eda4.png";